/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ButtonArchive.vue?vue&type=template&id=60534672"
import script from "./ButtonArchive.ts?vue&type=script&lang=ts&external"
export * from "./ButtonArchive.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports